import script from "./ExportImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportImage.vue?vue&type=script&lang=ts&setup=true"

import "./ExportImage.vue?vue&type=style&index=0&id=33da3f29&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33da3f29"]])

export default __exports__